module.exports = __webpack_public_path__ + "static/media/Logo.f61816ec.jpg";